




















































































import { Component, Vue } from 'vue-property-decorator';
import DashboardStat1 from '../components/dashboard/DashboardStat1.vue'
import DashboardRecent from '../components/dashboard/DashboardRecent.vue'
import * as Resource from '@/api/Resource'

@Component({
  components: {
    'dashboard-stata1': DashboardStat1,
    'dashboard-recent': DashboardRecent,
  },
})
export default class Dashboard extends Vue {
  dashboardCardStats = [
    {
      title: 'users',
      color: "#3F6791",
      icon: 'mdi-account-multiple',
      value: 0
    },
    {
      title: 'topups',
      color: "#45BB77",
      icon: 'mdi-account-multiple',
      value: 0
    },
    {
      title: 'topup amounts',
      color: "#BB9988",
      icon: 'mdi-account-multiple',
      value: 0
    },
    {
      title: 'points',
      color: "#334433",
      icon: 'mdi-account-multiple',
      value: 0
    }
  ];

  recentJoinedUsers: any = [];
  loadingRecentUsers = true;

  recentTransactions: any = [];
  loadingrecentTransactions = true;

  async reloadRecentJoinedUsers() {
    this.loadingRecentUsers = true;
    const recentUsers = await Resource.users.getUsers().get();
    this.recentJoinedUsers = recentUsers?.data.map((user: any) => ({ name: user.displayName, photo: user?.profilePhotoUrl })).slice(0,4);
    this.loadingRecentUsers = false;
  }

  async reloadRecentTransactions() {
    this.loadingrecentTransactions = true;
    const recentTransactionRes = await Resource.transactions.getAllTransactions().get();
    this.recentTransactions = recentTransactionRes?.data.map((transaction) => ({ ...transaction })).slice(0,4);
    this.loadingrecentTransactions = false;
  }

  async created() {
    const userCount = await Resource.users.getUsersCount().get();
    const topupCount = await Resource.transactions.getTransactionCounts().get();
    const topupAmountCount = await Resource.transactions.getTopupAmountsCounts().get();
    const pointsCount = await Resource.points.getPointsCount().get();

    this.dashboardCardStats = [
    {
      title: 'users',
      color: "#3F6791",
      icon: 'mdi-account-multiple',
      value: userCount?.data?.count
    },
    {
      title: 'topups',
      color: "#45BB77",
      icon: 'mdi-account-multiple',
      value: topupCount?.data?.count
    },
    {
      title: 'topup amounts',
      color: "#BB9988",
      icon: 'mdi-account-multiple',
      value: topupAmountCount?.data?.count
    },
    {
      title: 'points',
      color: "#334433",
      icon: 'mdi-account-multiple',
      value: pointsCount?.data?.count
    }
    ]

    this.reloadRecentJoinedUsers();
    this.reloadRecentTransactions();

    // const recentUsers = await Resource.users.getUsers().get();
    // this.recentJoinedUsers = recentUsers?.data.map((user) => ({ name: user.displayName, photo: user?.profilePhotoUrl })).slice(0,4);
  
  }
}
